<template v-if="props.open">
	<div class="fixed z-30 bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
		<div class="fixed inset-0 transition-opacity">
			<div class="absolute inset-0 bg-gray-900 opacity-75"></div>
		</div>
		<div class="w-[40rem] mx-auto py-6 sm:px-6 lg:px-8 z-10">
			<!-- Replace with your content -->

			<div class="bg-white p-4 rounded-lg shadow-xl ">
				<div class="flex items-center justify-between mb-1 rounded-lg">
					<div class="flex items-center">
						<h2 class="text-2xl font-googleBold">{{ isEditingExisting ? 'Edit' : 'New' }} Collection</h2>
					</div>
					<svg @click="$emit('close')" class="w-6 h-6 cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
				</div>
				<p v-if="isEditingExisting" class="text-xs text-gray-700 mb-3">Be mindful of edits that may impact the ability for existing team members to recognize and access this collection in the future. Users are not notified when they have been added or removed at this time.</p>
				<p v-else class="text-xs text-gray-700 mb-3">Create new collections to store unique sets of slides, as slides may only belong to a single collection at a time. Most organizations use collections at the business unit or division level. Secret or Private collections may be useful within departments.</p>


				<div class="grid grid-cols-1 gap-6 relative z-30">

					<div class="relative">
						<div class="-m-px border border-gray-300 h-full rounded-lg shadow-sm focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500">
							<input type="text" name="title" id="title"
								   class="w-full border-0 pt-2.5 text-lg font-medium bg-transparent placeholder-gray-500 focus:ring-0"
								   v-model="form.collectionTitle"
								   placeholder="Collection Name"/>
							<textarea rows="5" name="description" id="description"
									  v-model="form.description"
									  class=" w-full border-0 py-0 resize-none placeholder-gray-500 focus:ring-0 sm:text-sm"
									  placeholder="Optionally, add a description for your new collection."/>

							<div v-if="isEditingExisting" class="absolute bg-white border border-gray-300 rounded-full px-2 text-gray-500 py-px text-sm flex-none top-3 right-3">{{ props.existing.slides_count }} slides</div>

						</div>

						<div class="absolute bottom-2 w-full flex items-center justify-between">
							<div class="flex">
								<!-- Permission Options -->
								<Menu>
									<MenuButton class="relative inline-flex items-center rounded-full ml-2 py-2 px-2 bg-gray-50 text-sm font-medium text-gray-500 whitespace-nowrap hover:bg-gray-100 sm:px-3">
										<span class="inline-flex">
											<span v-html="selectedVisibility.icon"/>
											<span class="text-gray-900 ml-2">{{ selectedVisibility.shortName }}</span>
										</span>
									</MenuButton>
									<transition
										enter-active-class="transition duration-100 ease-out"
										enter-from-class="transform scale-95 opacity-0"
										enter-to-class="transform scale-100 opacity-100"
										leave-active-class="transition duration-75 ease-in"
										leave-from-class="transform scale-100 opacity-100"
										leave-to-class="transform scale-95 opacity-0"
									>
										<MenuItems class="absolute mt-4 w-full top-full origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
											<div class="px-1 py-1">
												<MenuItem v-slot="{ active }" v-for="(option, index) in visibilityOptions" :key="index" as="div">
													<button @click="setVisibility(option)"
															:class="[active ? 'bg-indigo-700 text-white' : 'text-gray-900','group w-full items-center rounded-md px-2 py-2 text-sm']">
														<div class="flex mb-1 font-black">
															<span v-html="option.icon"/>
															{{ option.shortName }}
														</div>

														<div class="text-xs text-left">
															{{ option.description }}
														</div>
													</button>
												</MenuItem>
											</div>
										</MenuItems>
									</transition>
								</Menu>
								<!-- End Permission Options -->

								<!-- Visibility Options -->
								<Menu>
									<MenuButton class="relative inline-flex items-center rounded-full ml-2 py-2 px-2 bg-gray-50 text-sm font-medium text-gray-500 whitespace-nowrap hover:bg-gray-100 sm:px-3">
										<span class="inline-flex">
											<span v-html="selectedPermission.icon"/>
											<span class="text-gray-900 ml-2">{{ selectedPermission.shortName }}</span>
										</span>
									</MenuButton>
									<transition
										enter-active-class="transition duration-100 ease-out"
										enter-from-class="transform scale-95 opacity-0"
										enter-to-class="transform scale-100 opacity-100"
										leave-active-class="transition duration-75 ease-in"
										leave-from-class="transform scale-100 opacity-100"
										leave-to-class="transform scale-95 opacity-0"
									>
										<MenuItems class="absolute mt-4 w-full top-full origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
											<div class="px-1 py-1 z-30">
												<MenuItem v-slot="{ active }" v-for="(option, index) in permissionOptions" :key="index" as="div">
													<button @click="setPermission(option)"
															:class="[active ? 'bg-indigo-700 text-white' : 'text-gray-900','group w-full items-center rounded-md px-2 py-2 text-sm']">
														<div class="flex mb-1 font-black">
															<span v-html="option.icon"/>
															{{ option.shortName }}
														</div>

														<div class="text-xs text-left">
															{{ option.description }}
														</div>
													</button>
												</MenuItem>
											</div>
											<div class="px-2 py-2 text-xs italic">
												<div class="font-black">Remember:</div>
												Users may always add and edit their own contributed slides to collections they are a part of. Any user that has viewing permissions to any slide may use those slides to generate new presentations.
											</div>
										</MenuItems>
									</transition>
								</Menu>
								<!-- End Visibility Options -->
							</div>


							<!-- Trash can -->
							<div @click="pendingDelete = true" v-if="!pendingDelete && isEditingExisting" class="hover:text-red-400 pr-3 text-gray-400 cursor-pointer">
								<!-- trash can symbol -->
								<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
							</div>
							<!-- End Trash can -->

						</div>
					</div>
				</div> <!-- Grid end --->


				<div v-if="selectedVisibility.shortName !== 'Public'" class="relative z-20">
					<!-- Add Users lookup --->
					<Combobox as="div" v-model="form.selectedPeople" by="id" multiple>


						<div class="relative mt-3">
							<ComboboxInput placeholder="Search to add team members..." class="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-12 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" @change="query = $event.target.value"/>

							<ComboboxButton class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
								<div class="rounded-full px-2 py-1 text-xs bg-gray-200 text-gray-500 mr-2">
									{{form.selectedPeople.length}} selected
								</div>

								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-gray-400">
									<path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
								</svg>



							</ComboboxButton>

							<ComboboxOptions v-if="filteredPeople.length > 0" class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
								<ComboboxOption v-for="person in filteredPeople" :key="person.id" :value="person" as="template" v-slot="{ active, selected }"
											:disabled="person.id === props.auth.user.id">
									<li :class="['relative cursor-default select-none py-2 pl-3 pr-9', active ? 'bg-indigo-600 text-white' : 'text-gray-900']">
										<div class="flex">
											<span :class="['truncate', selected && 'font-semibold']">
												{{ person.name }}
											</span>
											<span v-if="person.email !== person.name" :class="['ml-2 truncate text-gray-500', active ? 'text-indigo-200' : 'text-gray-500']">
												{{ person.email }}
											</span>
											<span v-if="person.id === props.auth.user.id" class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-500 text-gray-200">
												YOU
											</span>
										</div>

										<span v-if="selected" :class="['absolute inset-y-0 right-0 flex items-center pr-4', active ? 'text-white' : 'text-indigo-600']">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
												<path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd" />
											</svg>

										</span>
									</li>
								</ComboboxOption>
							</ComboboxOptions>
						</div>
					</Combobox>
					<!-- End Add Users lookup --->

					<div class="flex justify-end flex-wrap py-2 px-2 gap-2 sm:px-3">

						<div v-for="(person,index) in form.selectedPeople" :key="index"
							 class="relative inline-flex items-center rounded-full py-1 px-2 text-xs font-medium z-0 whitespace-nowrap bg-gray-100 text-gray-500 hover:bg-gray-200"
						>
							<span>{{ person.name }}</span>
							<button v-if="person.id !== props.auth.user.id" @click="removePerson(person.id)">
								<svg xmlns="http://www.w3.org/2000/svg"
									 class="flex-shrink-0 h-5 w-5 ml-1 text-gray-300" viewBox="0 0 20 20"
									 fill="currentColor">
									<path fill-rule="evenodd"
										  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
										  clip-rule="evenodd"/>
								</svg>
							</button>

						</div>


					</div>



				</div>


				<div class=" w-full">

					<div v-if="pendingDelete && props.existing.slides_count > 0" class="text-sm text-red-600 mt-2">
						You cannot delete a collection that still has slides. Please move remaining slides to a new collection. You may only delete a collection with no slides.
					</div>

					<div class="pt-4 flex justify-between items-center space-x-3 ">
						<div class="flex items-center font-medium px-3 py-2 text-gray-400 text-sm border rounded-full">
							<img v-if="props.auth.user.current_team.name !== 'Personal'" :src="'https://www.google.com/s2/favicons?domain=' + props.auth.user.current_team.domain + '&sz=128'" class="h-4 mr-2">
							<span class="pr-2">{{ props.auth.user.current_team.name }}</span>
						</div>

						<!-- normal save/edit -->
						<div v-if="!pendingDelete" class="flex items-center flex-shrink-0">

							<div @click="emit('close')" class="cursor-pointer hover:text-gray-900 px-3 text-gray-500 text-sm">
								Cancel
							</div>

							<!-- submit button -->
							<button @click="addCollection()"
									class="items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white w-36 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
									:class="[form.collectionTitle.length > 0 ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-gray-200 cursor-not-allowed hover:bg-gray-300']"
									:disabled="(form.collectionTitle.length < 0) || form.processing"

							>
								<span v-if="!form.processing">
									{{ isEditingExisting ? 'Save' : 'Add' }} Collection
								</span>
								<span v-else class="flex justify-center w-full">
									<svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
										<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
										<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
									</svg>
								</span>
							</button>
						</div>
						<!-- end normal save/ edit -->

						<!-- when pending delete -->
						<div v-if="pendingDelete" class="flex items-center flex-shrink-0">

							<div @click="pendingDelete = false;" class="cursor-pointer hover:text-gray-900 px-3 text-gray-500 text-sm">
								Cancel Delete
							</div>

							<!-- submit button -->
							<button @click="deleteCollection"
									class="items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white w-36 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
									:class="[props.existing.slides_count === 0 ? 'bg-red-600 hover:bg-red-700' : 'bg-red-200 cursor-not-allowed hover:bg-red-300']"
									:disabled="(props.existing.slides_count > 0) || deleteForm.processing"

							>
								<span v-if="!deleteForm.processing">
									Delete Collection
								</span>
								<span v-else class="flex justify-center w-full">
									<svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
										<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
										<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
									</svg>
								</span>
							</button>
						</div>
						<!-- end when pending delete -->





					</div>
				</div>



			</div>
		</div>



		<!-- /End replace -->



	</div>




</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {Combobox,ComboboxButton,ComboboxInput,ComboboxOption,ComboboxOptions,Menu,MenuButton,MenuItem,MenuItems} from '@headlessui/vue'
import {useForm} from '@inertiajs/vue3'


const props = defineProps({
	open: {type: Boolean, default: false},
	auth: {type: Object},
	existing: {type: Object, Default: {}}

});

const isEditingExisting = ref(false);

onMounted(() => {

	if(props.existing) { // this means we're in an edit request
		isEditingExisting.value = true;
		form.id = props.existing.id;
		form.collectionTitle = props.existing.name;
		form.description = props.existing.description;
		selectedPermission.value = permissionOptions[permissionOptions.findIndex(option => option.slug === props.existing.permission)];
		selectedVisibility.value = visibilityOptions[visibilityOptions.findIndex(option => option.shortName.toLowerCase() === props.existing.visibility)];

		if(props.existing.visibility === 'private' || props.existing.visibility === 'secret') {
			fetchTeamMembers();
		}

		form.selectedPeople = props.existing.users;

	}


});

const visibilityOptions = [
	{shortName: 'Public', description: 'Anyone on your team can see and join this collection.', icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 h-5 w-5 mr-1"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>'},
	{shortName: 'Private', description: 'Only added members can view slides, others may request access.', icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 h-5 w-5 mr-1"><path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" /></svg>'},
	{shortName: 'Secret', description: 'Only members manually added can see this collection, it is hidden otherwise. Team admins can see, but still must be added to view slides.', icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 h-5 w-5 mr-1"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" /></svg>'},
]


const selectedVisibility = ref(visibilityOptions[0])
function setVisibility(option) {
	selectedVisibility.value = option;

	if(option.shortName === 'Private' || option.shortName === 'Secret') {
		fetchTeamMembers();
	}
}



const permissionOptions = [
	{slug: 'edit', shortName: 'View + Edit', description: 'Members can edit any slide within this collection.', icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="flex-shrink-0 h-5 w-5 mr-1"><path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z" /></svg>'},
	{slug: 'view', shortName: 'View Only', description: 'Members may only view slides within collection.', icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 h-5 w-5 mr-1"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>'},
]

const selectedPermission = ref(permissionOptions[0])
function setPermission(option) {
	selectedPermission.value = option;
}


function fetchTeamMembers() {

	if(people.value.length === 0) { // ignore if members were already pulled

		axios.get('/team/members')
			.then((response) => {
				people.value = response.data;
				validateCurrentUserIsAlwaysSelected();
			});

	} else {
		validateCurrentUserIsAlwaysSelected();
	}

}

function validateCurrentUserIsAlwaysSelected() {
	props.auth.user.id // current user ID

	// add the user from the "people" const to the form.selectedPeople array by matching based on the ID of the user user
	const currentUser = people.value.find(user => user.id === props.auth.user.id);

	if (currentUser) {
		// Check if the user is already in the form.selectedPeople array
		const isAlreadySelected = form.selectedPeople.some(user => user.id === props.auth.user.id);

		if (!isAlreadySelected) {
			console.log("Adding user to array");
			// Add the user to the form.selectedPeople array
			form.selectedPeople.push(currentUser);
		}
	} else {
		console.warn(`User with ID ${props.auth.user.id} not found in the people array.`);
	}
}

const people = ref([]);

const query = ref('')


const filteredPeople = computed(() =>
	query.value === ''
		? people.value
		: people.value.filter((person) => {
			return person.name.toLowerCase().includes(query.value.toLowerCase())
		})
)

function removePerson(personId) {
	form.selectedPeople = form.selectedPeople.filter((person) => person.id !== personId);
}




const form = useForm({
	id: '',
	collectionTitle: '',
	description: '',
	visibility: selectedVisibility.value.shortName,
	permission: selectedPermission.value.shortName,
	selectedPeople: [],
});




function addCollection() {

	if(!form.processing) {
		form.transform((data) => ({
			...data,
			visibility: selectedVisibility.value.shortName,
			permission: selectedPermission.value.shortName,
		}))
			.post('/collection', {
			onError: () => {
				// newCollectionDuplicateWarning.value = true
				// form.newCollectionName = 'Duplicate collection name!';
				// setTimeout(() => {
				// 	newCollectionDuplicateWarning.value = false;
				// 	form.newCollectionName = '';
				// }, 3000)
			},
			onSuccess: () => {
				console.log("saved");
				emit('close');

				document.activeElement.blur();
				// form.newCollectionName = '';
			}
		});
	}
}

const deleteForm = useForm({})
function deleteCollection() {
	if(!deleteForm.processing) {
		deleteForm.transform(() => ({
			delete: props.existing.id,
		}))
			.delete('/collection', {
				onError: () => {
					// newCollectionDuplicateWarning.value = true
					// form.newCollectionName = 'Duplicate collection name!';
					// setTimeout(() => {
					// 	newCollectionDuplicateWarning.value = false;
					// 	form.newCollectionName = '';
					// }, 3000)
				},
				onSuccess: () => {
					console.log("deleted");
					emit('close');

					document.activeElement.blur();
					// form.newCollectionName = '';
				}
			});
	}
}



const selectedCollection = ref(props.activeCollection)


const emit = defineEmits(['close']);


const pendingDelete = ref(false);




</script>
